/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'react-bootstrap';
import SVGComponent from '../../../SharedModules/SVGComponents/SVGComponents';
import TableGrid from '../../../SharedModules/Table/TableGridWithFeatures';
import { EnrollmentHead } from './tablehead';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../SharedModules/AgGridUtilities/suppressNavigation';
import SaveCancelPopup from '../../../SharedModules/CustomSaveCancelPopup/SaveCancelPopup';
import { getCheckPay } from './store/actions';

const EnrollmentTab = (props) => {
  const {
    gridData,
    enrollFrameworkComponents,
    enrollRecordAdd,
    gridParamsSet,
    enrollRecordDelete,
    handleFullScreen,
    isEnablebyRole
  } = props;
  const dispatch = useDispatch();
  const [deleteModal, setDeleteModal] = React.useState(false);
  const [enrollFullScreen, setEnrollFullScreen] = React.useState(false);
  const enroll_time = useSelector(
    (state) => state?.sharedState?.RebatePgmReducer?.enroll_time
  );
  React.useEffect(() => {
    if (!enroll_time) dispatch(getCheckPay('ENROLLMENT_TIMING_CD'));
  }, []);
  const onGridReady = (params) => {
    gridParamsSet(params);
  };
  return (
    <>
      {/* {!enrollFullScreen && (
        <div className="btn-wrapper mb-2">
          <div className="float-right">
            <Button
              className="btn btn-success"
              onClick={() => enrollRecordAdd()}
            >
              <SVGComponent iconName="Icon-outline-add-circle" /> Add
            </Button>
            <Button
              className="btn btn-cancel"
              onClick={() => setDeleteModal(true)}
            >
              <SVGComponent iconName="Icon-delete" /> Delete
            </Button>
          </div>
        </div>
      )} */}
      <div className="clearfix" />
      <div className="panel-body FRR-custom-table tbl-manufacturer-inner frr-rbtprg-tblselectbox">
        <TableGrid
          data-testid="enroll"
          // rowData={gridData || []}
          rowData={
            gridData &&
            gridData?.map((item) => {
              const firstDropdownVal = enroll_time?.filter((x) => {
                return (
                  x.codeValueID &&
                  x.codeValueID?.codeValue === item.enrollmentTimingCd
                );
              });
              if (firstDropdownVal && firstDropdownVal.length > 0) {
                item.enrollmentTimingDD = `${
                  firstDropdownVal[0].codeValueID &&
                  firstDropdownVal[0].codeValueID.codeValue
                } - ${firstDropdownVal[0].shortDescription}`;
              } else {
                item.enrollmentTimingDD = null;
              }
              return item;
            })
          }
          gridHeight={enrollFullScreen ? '70vh' : 360}
          handleFullScreenViewClick={() => {
            setEnrollFullScreen(!enrollFullScreen);
            handleFullScreen(!enrollFullScreen);
          }}
          noGlobalSort
          fullScreenView={enrollFullScreen}
          hideColumnsInPdf={['delete']}
          addButtonText="Add Enrollment"
          disableAdd={ !isEnablebyRole}
          handleAddNewRow={(e) => enrollRecordAdd()}
          columnDefs={EnrollmentHead}
          navigateToNextCell={navigateToNextCell}
          // tabToNextCell={tabToNextCell}
          enterMovesDown
          suppressCellFocus
          exportFile
          gridCall={onGridReady}
          fileName="Enrollment"
          onCellFocused={onCellFocused}
          frameworkComponents={enrollFrameworkComponents}
        />
      </div>
      <div className="clearfix" />
      {/* <SaveCancelPopup
        open={deleteModal}
        data-test="cancelPopup"
        title="Delete"
        onConfim={() => {
          setDeleteModal(false);
          enrollRecordDelete();
        }}
        onCancel={(e) => setDeleteModal(false)}
        moduleName={`selected row(s)`}
      /> */}
    </>
  );
};
export default EnrollmentTab;
